/* eslint-disable eqeqeq */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-use-before-define */
import { useEffect, useState } from "react";
import RadioForm from "../../components/forms/radioForm";
import CustomAccordion from "../../components/ui/accordion";
import ProductActivationDevices from "../../features/hospitalManagement/devices";
import SelectForm from "../../components/forms/selectForm";
import { serviceTypeData, validityData } from "../../jsonData/addHospitalsData";
import { AmountInputForm } from "../../components/forms/inputForm";
import { fabClasses, SelectChangeEvent } from "@mui/material";
import DataPickForm from "../../components/forms/dataPickForm";
import moment from "moment";
import addHospitalName from "../../constants/hospitalManagement/addHospital";
import { useSelector } from "react-redux";
import ProductServiceCheckBox from "../../components/hospitalManagement/productServiceCheckBox";
import { labelObject } from "../../helper";
import { LoadingSpinner } from "../../components/ui/loadinSpinner";
import { managementAssistantListData } from "./dataformatter";
import { ThemeProvider } from "@mui/material/styles";
import { dateErrorTheme } from "../../components/themeProvider";
import { useQuery } from "@tanstack/react-query";
import { subscriptionPackageType } from "../../redux/addHospital/hospitalManagementReducer";
import ProductCheckBox from "../../components/hospitalManagement/productCheckbox";
import FormCheckBox from "../../components/hospitalManagement/FormCheckBox";

const ManagementAssistant = ({
  control,
  setValue,
  watch,
  previousDataPA,
  clearErrors,
  register,
}: any) => {
  const currentDate = new Date();
  const formatedCurrentDate = moment(currentDate).format("YYYY-MM-DD");
  const prdouctServiceList = useSelector(
    (data: any) => data?.getProductService
  );

  const { data: subscriptionType, isLoading } = useQuery({
    queryKey: ["subscriptionType"],
    queryFn: () => subscriptionPackageType(),
  });
  const enumData = useSelector((data: any) => data?.enumData?.data);
  const devicesList: any = useSelector((data: any) => data?.getDevices);

  const planTypeList = labelObject(enumData?.PlanType?.data);
  const patientTypeList = labelObject(enumData?.PatientType?.data);

  const { managementAssistantList } =
    managementAssistantListData(prdouctServiceList);

  const [priceOption, setpriceOption] = useState(
    previousDataPA?.maInPatientAmount && previousDataPA?.maOutPatientAmount
      ? "maIndividual"
      : ""
  );

  const maPatientType = watch("maPatientType");
  const maServiceType = watch("maServiceType");
  const maValidityFrom = watch("maValidityFrom");
  const maValidityPeriod = watch("maValidityPeriod");
  const maInPatientAmount = watch("maInPatientAmount");
  const maOutPatientAmount = watch("maOutPatientAmount");
  const pilotFromDate = watch("pilotFromDate");
  const pilotToDate = watch("pilotToDate");
  const isPilot = watch("isPilot");
  const trialMonths = watch("trialPeriod");
  const maPlanType = watch("maPlanType");
  const mareportingAmount = watch("mareportingAmount");
  const maCommunicationAmount = watch("maCommunicationAmount");
  const maDigitalMarketingAmount = watch("maDigitalMarketingAmount");

  // const hospitalOnbaordDate = watch("hospitalOnbaordDate");
  const AddonManagementReport = watch("MAaddOnService")?.find((item: any) => item.serviceId == 1000);
  const AddonCommunication = watch("MAaddOnService")?.find((item: any) => item.serviceId == 1001);
  const AddonDigitalMarketing = watch("MAaddOnService")?.find((item: any) => item.serviceId == 1002);
  console.log(AddonManagementReport, AddonDigitalMarketing, "hospitalOnbaordDate")

  //     useEffect(() => {
  //   if (previousDataPA?.maPatientType) {
  //     setValue("maPatientType", previousDataPA.maPatientType);
  //   }
  // }, [previousDataPA]);

  // const maPatientType = watch("maPatientType");

  // 
  useEffect(() => {
    if (maServiceType == "pilot") {
      setValue("maAllAmount", 0);
      setValue("maInPatientAmount", 0);
      setValue("maOutPatientAmount", 0);
    }
  }, [maServiceType]);
  useEffect(() => {
    if (!previousDataPA?.maPlanType) {
      setValue("maPlanType", "per_annum");
    }
    if (!previousDataPA?.maValidityPeriod) {
      setValue("maValidityPeriod", "validity_12_months");
    }
    if (!previousDataPA?.trialPeriod) {
      setValue("trialPeriod", "3");

    }
  }, []);



  const trialPeriod_Gold = [
    {
      value: '0',
      label: "0 Months"
    },
    {
      value: '1',
      label: "1 Month"
    }, {
      value: '2',
      label: "2 Months"
    }, {
      value: '3',
      label: "3 Months"
    },
    {
      value: '4',
      label: "4 Months"
    },
    {
      value: '5',
      label: "5 Months"
    },
    {
      value: '6',
      label: "6 Months"
    }];
  // useEffect(() => {
  //   if (maValidityFrom) {
  //     let toDateValidityUpdate;

  //     switch (maValidityPeriod) {
  //       case "validity_3_months":
  //         toDateValidityUpdate = moment(maValidityFrom)
  //           .add(3, "months")   // ✅ add first
  //           .subtract(1, "day") // ✅ subtract one day after
  //           .format("YYYY-MM-DD");
  //         break;

  //       case "validity_6_months":
  //         toDateValidityUpdate = moment(maValidityFrom)
  //           .add(6, "months")
  //           .subtract(1, "day")
  //           .format("YYYY-MM-DD");
  //         break;

  //       case "validity_12_months":
  //         toDateValidityUpdate = moment(maValidityFrom)
  //           .add(12, "months")
  //           .subtract(1, "day")
  //           .format("YYYY-MM-DD");
  //         break;

  //       case "custom":
  //         toDateValidityUpdate = previousDataPA?.maValidityto ?? "";
  //         break;

  //       case "lifetime":
  //         toDateValidityUpdate = moment(maValidityFrom)
  //           .add(20, "years")
  //           .subtract(1, "day")
  //           .format("YYYY-MM-DD");
  //         break;

  //       default:
  //         toDateValidityUpdate = "";
  //     }

  //     setValue("maValidityto", toDateValidityUpdate);
  //   }
  // }, [maValidityFrom, maValidityPeriod]);


  console.log(watch('MAaddOnService'), "productInfo")

  useEffect(() => {
    if (!maValidityFrom) return;

    let toDateValidityUpdate;

    switch (maValidityPeriod) {
      // case "validity_3_months":
      //   toDateValidityUpdate = moment(maValidityFrom)
      //     .add(3, "months")
      //     .subtract(1, "day");
      //   break;

      // case "validity_6_months":
      //   toDateValidityUpdate = moment(maValidityFrom)
      //     .add(6, "months")
      //     .subtract(1, "day");
      //   break;

      case "validity_12_months":
        toDateValidityUpdate = moment(maValidityFrom)
          .add(12, "months")
          .subtract(1, "day");
        break;

      // case "lifetime":
      //   toDateValidityUpdate = moment(maValidityFrom)
      //     .add(20, "years")
      //     .subtract(1, "day");
      //   break;

      case "custom":
        setValue("maValidityto", previousDataPA?.maValidityto ?? "");
        return;

      default:
        return;
    }



    // Add pilot duration
    if (isPilot && pilotFromDate && pilotToDate) {
      const pilotDays =
        moment(pilotToDate).diff(moment(pilotFromDate), "days") + 1;

      toDateValidityUpdate = moment(toDateValidityUpdate).add(
        pilotDays,
        "days"
      );
    }

    setValue(
      "maValidityto",
      moment(toDateValidityUpdate).format("YYYY-MM-DD")
    );
  }, [
    maValidityFrom,
    maValidityPeriod,
    pilotFromDate,
    pilotToDate,
    isPilot,
  ]);

  // Free Trial Period Calculation
  useEffect(() => {
    if ((watch("subscriptionPackage") == 2 || watch("subscriptionPackage") == 3) && watch("trialPeriod") && watch("pilotFromDate") && watch("pilotToDate")) {
      setValue("trialFromDate", moment(pilotToDate).add(1, "day"));
      setValue("trialToDate", moment(pilotToDate).add(trialMonths, "months").subtract(1, "day"));
    }
  }, [pilotFromDate, pilotToDate, trialMonths, watch("subscriptionPackage")]);

  console.log(watch("trialPeriod"), watch("subscriptionPackage"), "trialPeriod")

  // const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setValue("maPatientType", e.target.id);
  //   if (e.target.value == "all") {
  //     setValue("maInPatientAmount", 0);
  //     setValue("maOutPatientAmount", 0);
  //     setpriceOption("maBulk");
  //   }
  //   // if (e.target.value == "in_patient") {
  //   //   setValue("maAllAmount", "");
  //   //   setValue("maOutPatientAmount", "");
  //   //   setpriceOption("");
  //   // }
  //   if (e.target.value == "out_patient") {
  //     setValue("maAllAmount", 0);
  //     setValue("maInPatientAmount", 0);
  //     setpriceOption("");
  //   }
  // };

  // const handlePlanTypeChange = (e: SelectChangeEvent<any>) => {
  //   if (e.target.value == "per_patient" || e.target.value == "per_month"||e.target.value == "per_annum") {
  //   //   setValue("maValidityPeriod", "none");
  //   //   setValue("maValidityFrom", "0001-01-01");
  //   //   setValue("maValidityto", "0001-01-01");
  //   // } else if (e.target.value == "per_annum") {
  //   //   setValue("maValidityPeriod", "");
  //     setValue("maValidityFrom", formatedCurrentDate);
  //     setValue("maValidityto", "");
  //     setValue("pilotFromDate", formatedCurrentDate);
  //     setValue("pilotToDate", "");
  //   }
  // };


  const displayreportType = watch("MAaddOnService")?.find(
    (item: any) => item.serviceId == 1000
  );

  // const handleValidityPeriod = (value: string) => {
  //   clearErrors("maValidityto");
  // };

  // const priceOptionList = [
  //   { value: "maBulk", label: "Bulk" },
  //   { value: "maIndividual", label: "Individual" },
  // ];

  // const handlePriceOption = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   setpriceOption(e.target.id);
  //   setValue("maInPatientAmount", 0);
  //   setValue("maOutPatientAmount", 0);
  //   setValue("maAllAmount", 0);
  // };

  useEffect(() => {
    if (maPatientType == "all" || maPatientType == "out_patient") {
      // setValue("maAllAmount", 0);
      if (maInPatientAmount > 0 || maOutPatientAmount > 0) {
        const maAllAmountValue = (+maInPatientAmount) + (+maOutPatientAmount);

        setValue("maAllAmount", maAllAmountValue == 0 ? "" : maAllAmountValue);
      }
    }
    //     else if(maPlanType == "per_month" || maPlanType == "per_annum"&& maPatientType == "all"){
    //  setValue("maInPatientAmount", 0);
    //       setValue("maOutPatientAmount", 0);
    //     }else if(maPatientType == "out_patient"){
    //       setValue("maInPatientAmount", 0);
    //       setValue("maAllAmount", 0);
    //     }
    if (AddonManagementReport || AddonCommunication || AddonDigitalMarketing) {
      const maAddonServicesAmountValue = (+mareportingAmount) + (+maDigitalMarketingAmount) + (+maCommunicationAmount);

      setValue("maAddonServicesAllAmount", maAddonServicesAmountValue == 0 ? "" : maAddonServicesAmountValue);
      // setValue("maOutPatientAmount", 0);
      // setValue("mareportingAmount", 0);
      // setValue("maDigitalMarketingAmount", 0);
      // setValue("maCommunicationAmount", 0);

      // setValue("maAllAmount", "");

    }
  }, [maPlanType, maPatientType, maInPatientAmount, maOutPatientAmount, AddonManagementReport, AddonCommunication, AddonDigitalMarketing, mareportingAmount, maDigitalMarketingAmount, maCommunicationAmount]);

  useEffect(() => {
    if (maPatientType == "all") {
      setpriceOption(
        previousDataPA?.maInPatientAmount && previousDataPA?.maOutPatientAmount
          ? "maIndividual"
          : "maBulk"
      );
    }
  }, [maServiceType, maPatientType]);


  useEffect(() => {
    if (!watch("MAaddOnService")?.some((v: any) => v.serviceName == "Communication                         ")) {
      setValue("maCommunicationAmount", 0)
    }
    if (!watch("MAaddOnService")?.some((v: any) => v.serviceName == "Digital Marketing")) {
      setValue("maDigitalMarketingAmount", 0)
    }
    if (!watch("MAaddOnService")?.some((v: any) => v.serviceName == "Management Reporting")) {
      setValue("mareportingAmount", 0)
    }
  }, [watch("MAaddOnService")])



  // const maValidityFrom = watch("maValidityFrom");

  useEffect(() => {
    if (isPilot && maValidityFrom) {
      setValue("pilotFromDate", maValidityFrom);
    }
  }, [maValidityFrom, isPilot, setValue]);

  useEffect(() => {
    if (watch('maPlanType') == 'per_annum') {
      setValue('maOutPatientAmount', 0)
      setValue('maInPatientAmount', 0)
    }
    if (watch('maPlanType') == 'per_month') {
      setValue('maOutPatientAmount', 0)
      setValue('maInPatientAmount', 0)
    }
    if (watch('maPlanType') == 'per_patient') {
      setValue('maAllAmount', 0)
    }
  }, [watch('maPlanType')])

  // const validityDataFiltered = validityData.filter((item) => item.value !== "none");

  const filteredValidityOptions = maPlanType == "per_annum"
    ? validityData.filter((item) => item.value !== "custom")
    : validityData;

  console.log(priceOption, "clearerror")
  console.log(filteredValidityOptions, "filteredValidityOptions")
  // console.log("subscriptionType",managementAssistantList,watch("isPilot"),validityData,serviceTypeData, subscriptionType);
  // console.log("watch",watch("pilotFromDate"),maServiceType,maPatientType,priceOption)
  console.log(previousDataPA, "filteredValidityOptions")
  console.log(watch("MAaddOnService"), "MAaddOnService")
  return (
    <div>
      <span className="text-16 text-primary font-semibold">
        {addHospitalName.AddonService}
      </span>

      {prdouctServiceList?.status == "success" ? (
        <div className="flex max-md:flex-col  gap-4 py-4">
          <ProductServiceCheckBox
            data={managementAssistantList}
            setValue={setValue}
            control={control}
            name="MAaddOnService"
            defaultValue={previousDataPA?.MAaddOnService}
          />
        </div>
      ) : (
        <div className="flex justify-center py-2">
          <LoadingSpinner />
        </div>
      )}

      {displayreportType && (
        <div className={`  grid lg:grid-cols-3 md:grid-cols-2 gap-4 my-4`}>
          <div className="flex gap-3 my-3">
            <RadioForm
              label="Report Type"
              id="reportType"
              control={control}
              option1="weekly"
              option2="monthly"
              required={displayreportType ? true : false}
              defaultValue={previousDataPA?.reportType ?? "monthly"}
              className="flex-col"
            />
          </div>
        </div>
      )}

      <div>
        <CustomAccordion
          defaultOpen={false}
          isBorder={false}
          bgcolor=""
          innerPadding=""
          title="Devices"
          component={
            !devicesList?.isLoading ? (
              <ProductActivationDevices
                control={control}
                watch={watch}
                setValue={setValue}
                totalDevicesCount="maTotalDevicesCount"
                packageDevicesCount="maPackageDevicesCount"
                paidDevicesCount="maPaidDevicesCount"
                packageDevices="maPackageDevices"
                paidDevices="maPaidDevices"
                previousDataPA={previousDataPA}
                clearErrors={clearErrors}
              />
            ) : (
              <div className="flex justify-center py-2">
                <LoadingSpinner />
              </div>
            )
          }
        />

        <div className="my-3">
          <span className="text-18 text-primary font-semibold">
            {addHospitalName.PlanDetails}
          </span>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 my-6 align-items-start  jsustify-start">
            {/* <SelectForm
              label="Service Type*"
              id="maServiceType"
              options={serviceTypeData}
              control={control}
              defaultValue={previousDataPA?.maServiceType}
            /> */}

            {/* <div className={`  grid lg:grid-cols-3 md:grid-cols-2 gap-4 my-4`}> */}
            <div className="flex gap-3 my-1">
              <RadioForm
                label="Patient Type"
                id="maPatientType"
                control={control}
                option1="all"
                option2="out_patient"
                // required={displayreportType ? true : false}
                defaultValue={previousDataPA?.maPatientType ?? "all"}
                className="flex-row gap-5"
              />
            </div>
            {/* </div> */}
            {/* <SelectForm
              label={"Patient Type*"}
              id={"maPatientType"}
              options={patientTypeList}
              control={control}
              onChange={(e: SelectChangeEvent<any>) => handleChange(e)}
              defaultValue={previousDataPA?.maPatientType}
            /> */}
            <SelectForm
              label="Subscription Type*"
              id="subscriptionPackage"
              options={subscriptionType ?? []}
              control={control}
              defaultValue={previousDataPA?.subscriptionPackage}
            />
            {(watch("subscriptionPackage") == 2 || watch("subscriptionPackage") == 3) && (<>
              <SelectForm
                label="Trial Period (Gold)*"
                id="trialPeriod"
                options={trialPeriod_Gold ?? []}
                control={control}
                defaultValue={previousDataPA?.trialPeriod}
                required={watch("subscriptionPackage") == 2 || watch("subscriptionPackage") == 3 ? true : false}
              />

              {/* <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 my-6 items-center"> */}

              <ThemeProvider theme={dateErrorTheme}>
                <DataPickForm
                  label={"From"}
                  id="trialFromDate"
                  control={control}
                  disabled={true}
                  defaultValue={previousDataPA?.trialFromDate ?? ""}
                  // required={watch("maPlanType") == "per_annum" ? true : false}
                  required={watch("subscriptionPackage") == 2 || watch("subscriptionPackage") == 3 ? true : false}
                  minDate={moment(new Date())}
                />
              </ThemeProvider>

              <DataPickForm
                label={"To"}
                id="trialToDate"
                control={control}
                disabled={true}
                // disabled={watch("trialToDate") !== "custom" ? true : false}
                // required={
                //   watch("trialToDate") == "lifetime" ||
                //     watch("maPlanType") !== "per_annum"
                //     ? false
                //     : true
                // }
                required={watch("subscriptionPackage") == 2 || watch("subscriptionPackage") == 3 ? true : false}
                defaultValue={previousDataPA?.trialToDate}
                minDate={watch("trialFromDate")}
              />
              {/* </div> */}
            </>)}
          </div>

        </div>

        <div className="my-3">
          <div className="flex-col gap-5">
            <span className="text-18 text-primary font-semibold">
              {addHospitalName.Pricedeatail}
            </span>

            {/* {priceOption && (
              <div className="flex gap-3">
                {priceOptionList?.map((item: any) => (
                  <div className="flex items-center gap-2">
                    <input
                      type="radio"
                      id={item.value}
                      checked={item.value == priceOption}
                      name="maPriceOption"
                      onChange={(e) => handlePriceOption(e)}
                    />
                    <label
                      className={`font-14 font-medium ${item.value == priceOption
                        ? "text-primary"
                        : "text-secondary"
                        }`}
                      htmlFor={item.value}
                    >
                      {item?.label}
                    </label>
                  </div>
                ))}
              </div>
            )} */}


            <div className="flex gap-5 pt-3">
              <span className="text-16 text-primary font-semibold">
                {"Modules :"}
              </span>
            </div>
          </div>
          {/* <div className="grid lg:grid-cols-2 md:grid-cols-2 gap-6 my-6"> */}
          {/* <SelectForm
              label="Plan Type*"
              id="maPlanType"
              options={planTypeList}
              control={control}
              // onChange={(e: SelectChangeEvent<any>) => handlePlanTypeChange(e)}
              defaultValue={previousDataPA?.maPlanType}
            /> */}
          <div className="grid lg:grid-cols-3 md:grid-cols-2 items-center gap-6">

            <div className="flex gap-8 my-4 pb-5">
              <RadioForm
                label="Plan Type*"
                id="maPlanType"
                control={control}
                option1="per_annum"
                option2="per_month"
                option3="per_patient"

                // required={displayreportType ? true : false}
                defaultValue={previousDataPA?.maPlanType ?? "per_annum"}
                className="flex-col gap-5"
              />

            </div>
            <div className="flex gap-8 my-5 pb-5
          ">
              <AmountInputForm
                label={"Total Amount"}
                id="maAllAmount"
                control={control}
                disabled={
                  // maPatientType == "all" &&
                  (maPlanType !== "per_patient" && maPatientType == "all")
                    ? false

                    : true
                }
                required={
                  // maPatientType == "all" &&
                  maPlanType !== "per_patient" && maPatientType !== "out_patient"
                    ? true : false
                }
                defaultValue={previousDataPA?.maAllAmount}
                maxLength={50}
              />

            </div>
          </div>

          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-8 my-6">




            <AmountInputForm
              label={"In-Patient Amount"}
              id="maInPatientAmount"
              control={control}
              disabled={
                (maPlanType !== "per_patient")
                  ? true : maPatientType == "out_patient"
                    ? true
                    : false
              }
              required={
                maPlanType == "per_patient" &&
                  maPatientType == "all"
                  ? true
                  : false
              }
              defaultValue={previousDataPA?.maInPatientAmount}
              maxLength={50}
            />

            <AmountInputForm
              label={"Out-Patient Amount"}
              id="maOutPatientAmount"
              control={control}
              disabled={
                maPatientType == "out_patient" || maPlanType === "per_patient"
                  ? false
                  : true
              }
              required={
                maPlanType == "per_patient" &&
                  (maPatientType == "all" || maPatientType == "out_patient")
                  ? true
                  : false
              }
              defaultValue={previousDataPA?.maOutPatientAmount}
              maxLength={50}
            />
          </div>

          <div className="flex gap-5 pt-3">
            <span className="text-16 text-primary font-semibold">
              {"Add-On Services :"}
            </span>

          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 items-center gap-6">

            <div className="flex gap-8 my-5 pb-5">
              <RadioForm
                label="Plan Type*"
                id="maAddonServicePlanType"
                control={control}
                option1="per_annum"
                option2="per_month"
                // option3="per_patient"

                // required={displayreportType ? true : false}
                defaultValue={previousDataPA?.maAddonServicePlanType ?? "per_annum"}
                className="flex-col gap-5"
              />

            </div>
            <div className="flex gap-8 my-5 pb-5 ">
              <AmountInputForm
                label={"Total Amount"}
                id="maAddonServicesAllAmount"
                control={control}
                disabled={
                  watch("MAaddOnService")?.length < 0 || !watch("MAaddOnService")
                }
                required={
                  false
                }
                defaultValue={previousDataPA?.maAddonServicesAllAmount}
                maxLength={50}
              />

            </div>
          </div>
          <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 my-6">


            <AmountInputForm
              label={"Management Reporting Amount"}
              id="mareportingAmount"
              control={control}
              // disabled={
              //   (priceOption == "maIndividual" || maPatientType == "out_patient") &&
              //     (maPatientType == "all" || maPatientType == "out_patient") && AddonManagementReport
              //     ? false
              //     : true
              // }
              disabled={
                !watch("MAaddOnService")?.some((v: any) => v.serviceName == "Management Reporting")
              }
              required={
                (priceOption == "maIndividual" || maPatientType == "out_patient") &&
                  (maPatientType == "all" || maPatientType == "out_patient") && AddonManagementReport
                  ? true
                  : false
              }
              defaultValue={previousDataPA?.mareportingAmount || 0}
              maxLength={50}
            />
            <AmountInputForm
              label={"Digital Marketing Amount"}
              id="maDigitalMarketingAmount"
              control={control}
              // disabled={
              //   (priceOption == "maIndividual" || maPatientType == "out_patient") &&
              //     (maPatientType == "all" || maPatientType == "out_patient") && AddonDigitalMarketing
              //     ? false
              //     : true
              // }
              disabled={
                !watch("MAaddOnService")?.some((v: any) => v.serviceName == "Digital Marketing")
              }
              required={
                (priceOption == "maIndividual" || maPatientType == "out_patient") &&
                  (maPatientType == "all" || maPatientType == "out_patient") && AddonDigitalMarketing
                  ? true

                  : false
              }
              defaultValue={previousDataPA?.maDigitalMarketingAmount}
              maxLength={50}
            />
            <AmountInputForm
              label={"Communication Amount"}
              id="maCommunicationAmount"
              control={control}
              // disabled={
              //   (priceOption == "maIndividual" || maPatientType == "out_patient") &&
              //     (maPatientType == "all" || maPatientType == "out_patient") && AddonCommunication
              //     ? false
              //     : true
              // }
              disabled={
                !watch("MAaddOnService")?.some((v: any) => v.serviceName == "Communication                         ")
              }
              required={
                (priceOption == "maIndividual" || maPatientType == "out_patient") &&
                  (maPatientType == "all" || maPatientType == "out_patient") && AddonCommunication
                  ? true

                  : false
              }
              defaultValue={previousDataPA?.maCommunicationAmount}
              maxLength={50}
            />
          </div>
        </div>
        {/* </div> */}

        <div
        // className={`${watch("maPlanType") == "per_annum" ? "visible" : "hidden"
        // } `}
        >
          <hr />

          <div className="my-3">
            <span className="text-16 text-primary font-semibold">
              {addHospitalName.Validity}
            </span>
            <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 my-6 items-center">
              <div className="mt-2">
                <SelectForm
                  label={"Validity Period"}
                  id={"maValidityPeriod"}
                  options={filteredValidityOptions}
                  control={control}
                  // onChange={handleValidityPeriod}
                  defaultValue={previousDataPA?.maValidityPeriod}
                // required={watch("maPlanType") == "per_annum" ? true : false}
                />
              </div>
              <ThemeProvider theme={dateErrorTheme}>
                <DataPickForm
                  label={"From"}
                  id="maValidityFrom"
                  control={control}
                  defaultValue={
                    previousDataPA?.maValidityFrom ?? formatedCurrentDate
                  }
                  required={watch("maPlanType") == "per_annum" ? true : false}
                  minDate={moment(new Date())}
                />
              </ThemeProvider>

              <DataPickForm
                label={"To"}
                id="maValidityto"
                control={control}
                disabled={watch("maValidityPeriod") !== "custom" ? true : false}
                required={
                  watch("maValidityPeriod") == "lifetime" ||
                    watch("maPlanType") !== "per_annum"
                    ? false
                    : true
                }
                defaultValue={previousDataPA?.maValidityto}
                minDate={watch("maValidityFrom")}
              />
            </div>
            <div className="my-3">
              <FormCheckBox
                control={control}
                id="isPilot"
                name="isPilot"
                label="Pilot Period"
              />


              {watch("isPilot") && (
                <div className="grid lg:grid-cols-3 md:grid-cols-2 gap-6 my-6 items-center">

                  <ThemeProvider theme={dateErrorTheme}>
                    <DataPickForm
                      label={"From"}
                      id="pilotFromDate"
                      control={control}
                      defaultValue={previousDataPA?.pilotFromDate ?? watch("maValidityFrom")}
                      disabled={true}
                      // required={watch("maPlanType") == "per_annum" ? true : false}
                      minDate={moment(new Date())}
                    />
                  </ThemeProvider>

                  <DataPickForm
                    label={"To"}
                    id="pilotToDate"
                    control={control}
                    // disabled={watch("pilotToDate") !== "custom" ? true : false}
                    // required={
                    //   watch("pilotToDate") == "lifetime" ||
                    //     watch("maPlanType") !== "per_annum"
                    //     ? false
                    //     : true
                    // }
                    defaultValue={previousDataPA?.pilotToDate}
                    minDate={watch("pilotFromDate")}
                  />
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManagementAssistant;
